import { Paper, SxProps, Theme } from '@mui/material';

import { redirectTo } from '../../../utils/navigation';

const customStyles: Record<string, SxProps<Theme>> = {
  dsLogo: {
    zIndex: 1000,
    position: 'sticky',
    top: '0',
    width: '100%',
    padding: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    '& img': {
      width: 'auto',
      height: '80px',
    },
    '@media print': {
      display: 'none',
    },
  },
  dsLogoResponsive: {
    '@media (max-width: 768px)': {
      '& img': {
        width: 'auto',
        height: '60px',
      },
    },
  },
};

interface DsBannerProps {
  goToPage?: string | null;
}

export function DsBanner({ goToPage = null }: DsBannerProps) {
  return (
    <Paper
      elevation={1}
      sx={
        {
          ...customStyles.dsLogo,
          ...(goToPage ? { cursor: 'pointer' } : { pointerEvents: 'none', cursor: 'default' }),
        } as SxProps<Theme>
      }
      onClick={goToPage ? () => redirectTo(goToPage, true) : undefined}
    >
      <img
        src={
          'https://data-scope.s3.us-west-2.amazonaws.com/vendors/public/ds-logo-for-templates.png'
        }
        alt='DataScope logo'
      />
    </Paper>
  );
}
